import React from 'react';
import { FadeIn } from './FadeIn';
import { BatteryWarning, Coffee, Moon, Frown, CloudFog } from 'lucide-react';
const painPoints = [{
  icon: BatteryWarning,
  text: 'Te despiertas cansado, sin importar cuánto duermas.'
}, {
  icon: Coffee,
  text: 'Dependes de la cafeína para sobrevivir a la tarde.'
}, {
  icon: Moon,
  text: 'Cuando finalmente intentas dormir, tu cerebro no se apaga.'
}, {
  icon: Frown,
  text: 'Sientes irritabilidad constante y falta de enfoque.'
}, {
  icon: CloudFog,
  text: "Esa 'nube' mental te impide tomar decisiones rápidas."
}];
export function AgitationSection() {
  return <section className="py-14 px-4 md:px-6 relative bg-[#0a0e1a]" data-id="element-12">
      <div className="max-w-5xl mx-auto" data-id="element-13">
        <FadeIn data-id="element-14">
          <div className="text-center mb-10" data-id="element-15">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-16">
              Vives en un ciclo sin fin
            </h2>
            <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-17">
              Has intentado dormir más, pero nada cambia. El problema no es el
              descanso, es tu mecanismo de energía biológica.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-18">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-19">
              <div className="bg-slate-800/30 border border-slate-700/50 rounded-xl p-6 h-full flex flex-col items-center text-center hover:bg-slate-800/50 transition-colors" data-id="element-20">
                <div className="w-12 h-12 rounded-full bg-cyan-500/10 flex items-center justify-center mb-4" data-id="element-21">
                  <point.icon className="w-6 h-6 text-cyan-400" data-id="element-22" />
                </div>
                <p className="text-slate-300" data-id="element-23">{point.text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}